import Base from './base';
import UnderlyingSelect from './underlying-select';

const LABEL_NO_RESULTS = 'No quick links for this underlying';
const LABEL_UNDERLYING_PRODUCTS = 'View all products for this underlying';

const categoryLinkTemplate = (productCategory, isSubLink = false) => {
	const { productCount = 0 } = productCategory;
	const hasProducts = productCount > 0;
	const modifier = isSubLink ? 'underlying-select__list__link--sub' : '';

	if (hasProducts) {
		return `<a class="underlying-select__list__link ${modifier}" href="${productCategory.url}">${productCategory.title}</a>`;
	}

	return `<span class="underlying-select__list__link ${modifier} is-unavailable">${productCategory.title}</span>`;
};

const quickLinksTemplate = categories => categories.map(category => `
	<li class="underlying-select__list__item">
		${categoryLinkTemplate(category.mainQuickLink)}

		<ul class="underying-select__sublist">
			${category.additionalQuickLinks.map(subCategory => `
				<li class="underlying-select__sublist__item">
					${categoryLinkTemplate(subCategory, true)}
				</li>`).join('')}
		</ul>
	</li>
`).join('');

const noResultsTemplate = (labeLNoResults, labelOverview, overviewUrl) => `<li class="underlying-select__list-item-empty">
		${labeLNoResults}
		${overviewUrl ? `<a href="${overviewUrl}">${labelOverview}</a>` : ''}
	</li>`;

class UnderlyingQuickLinks extends Base {
	set isLoading(loading) {
		this.el.classList.toggle('is-loading', loading);
	}

	constructor(el) {
		super(el);

		this.underlyingSelect = new UnderlyingSelect({ el: this.refs.select });
		this.underlyingSelect.el.addEventListener('change', e => this.onUnderlyingSelected(e.target.value));
	}

	async start() {
		const { options: { underlyingApiUrl, preselected, exchangesToExclude, exchangesToInclude } } = this;

		if (!underlyingApiUrl) {
			console.warn('cannot create quick links without feedUrl');

			return;
		}

		this.isLoading = true;

		const trabeableApiUrl = `${underlyingApiUrl}/tradeable?exchangesToExclude=${exchangesToExclude}&exchangesToInclude=${exchangesToInclude}`;

		try {
			await this.underlyingSelect.init(trabeableApiUrl);

			this.underlyingSelect.select(preselected);
			this.fetchProductCategories();
		} catch (e) {
			console.warn('error while fetching:', e);

			this.el.classList.add('is-hidden');
		} finally {
			this.isLoading = false;
		}
	}

	onUnderlyingSelected(underlyingKey) {
		this.fetchProductCategories(underlyingKey);
	}

	async fetchProductCategories(underlyingKey = this.underlyingSelect.el.value) {
		if (!underlyingKey) {
			return;
		}

		const { options: { underlyingApiUrl, exchangesToExclude, exchangesToInclude } } = this;
		const categoriesApiUrl = `${underlyingApiUrl}/${underlyingKey}/quick-link-categories?exchangesToExclude=${exchangesToExclude}&exchangesToInclude=${exchangesToInclude}`;

		try {
			const response = await UnderlyingQuickLinks.fetchApiResponse(categoriesApiUrl);
			const { quickLinkLines = [] } = response;

			this.renderQuickLinks(quickLinkLines);
		} catch (e) {
			console.warn('error while fetching:', e);
			this.el.classList.add('is-hidden');
		} finally {
			this.isLoading = false;
		}
	}

	renderQuickLinks(categories) {
		if (categories.length) {
			this.refs.links.innerHTML = this.getQuickLinksHtml(categories);
		} else {
			this.refs.links.innerHTML = this.getnoResultsHtml();
		}

		this.refs.links.classList.add('is-updated');

		setTimeout(() => {
			this.refs.links.classList.remove('is-updated');
		}, 500);
	}

	getQuickLinksHtml(categories) {
		return quickLinksTemplate(categories);
	}

	getnoResultsHtml() {
		const {
			labelNoResults = LABEL_NO_RESULTS,
			labelUnderlyingProducts = LABEL_UNDERLYING_PRODUCTS,
		} = this.options;

		const { overviewUrl = null } = this.underlyingSelect.selectedUnderlying;

		return noResultsTemplate(labelNoResults, labelUnderlyingProducts, overviewUrl);
	}

	static async fetchApiResponse(url) {
		return fetch(url).then((res) => {
			if (res.ok) {
				return res.json();
			}

			throw new Error(res.statusText);
		});
	}
}

export default UnderlyingQuickLinks;
